import React, { useEffect, useState } from 'react';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
import { Button, Row, Col, Toast } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './global.css';
// components
import ScrollToTop from './components/ScrollToTop';
import { BaseOptionChartStyle } from './components/chart/BaseOptionChart';
import AuthAPI from './service/authAPI';
import AuthContext from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { HelpProvider } from './contexts/HelpContext';
import { getNotification } from './service/notificationApi';
import { ToastContainer } from 'react-toastify';
import GlobalStyles from '@mui/material/GlobalStyles';
import NetworkStatus from './components/NetworkStatus';
import DynamicFavicon from './components/DynamicFavicon';

// ----------------------------------------------------------------------
AuthAPI.setup();

export default function App() {
  const [user, setUser] = useState([]);
  const [isAuthenticated, setIsAuthenticated] = useState(AuthAPI.isAuthenticated());
  const [notifications, setNotifications] = useState([]);
  const [customerId, setCustomerId] = useState(AuthAPI.getCustomerId());

  const contextValue = { isAuthenticated, setIsAuthenticated, user, setUser, notifications, setNotifications, customerId, setCustomerId };

  useEffect(() => {
    if (isAuthenticated) {
      const id = AuthAPI.getCustomerId();
      setCustomerId(id);
    } else {
      setCustomerId(null);
    }
  }, [isAuthenticated]);

  // Ajouter la vérification périodique du token
  useEffect(() => {
    if (isAuthenticated) {
      const checkAuth = () => {
        if (!AuthAPI.isAuthenticated()) {
          setIsAuthenticated(false);
          setCustomerId(null);
          window.location.href = '/login';
        }
      };

      // Vérifier toutes les 5 minutes (plus fréquent)
      const interval = setInterval(checkAuth, 5 * 60 * 1000);
      return () => clearInterval(interval);
    }
  }, [isAuthenticated]);

  // Setup initial du token au démarrage
  useEffect(() => {
    const setupAuth = () => {
      const isSetup = AuthAPI.setup();
      if (isSetup !== isAuthenticated) {
        setIsAuthenticated(isSetup);
      }
    };

    setupAuth();
  }, []);

  /*useEffect(() => {
    const id = setInterval(fetchNotifications, 5000);
    return () => clearInterval(id);
  }, []);*/

  /*const fetchNotifications = async () => {
    getNotification().then((resp) => {
      setNotifications(resp);
    })
  };*/

  return (
    <>
      <DynamicFavicon />
      <AuthContext.Provider value={contextValue}>
        <NotificationProvider>
          <HelpProvider>
            <ThemeProvider>
              <GlobalStyles styles={BaseOptionChartStyle()} />
              <ToastContainer />
              <NetworkStatus />
              <ScrollToTop />
              <Router />
            </ThemeProvider>
          </HelpProvider>
        </NotificationProvider>
      </AuthContext.Provider>
    </>
  );
}
